import YoutubeColumns from '../components/landing/YoutubeColumns';
import { WALKTHROUGH_VIDEOS } from '../components/landing/walkthroughVideos';

const SUPPORT_EMAIL = 'support@amcscoring.com';

export default function SupportPage() {
  return (
    <main className="support-page">
      <section className="support-page__content">
        <header className="support-page__intro">
          <p className="support-page__kicker">Need a quick refresher?</p>
          <h1 className="support-page__heading">Walkthroughs & Support</h1>
          <p className="support-page__text">
            Browse the official walkthrough videos below
          </p>
        </header>
        <div className="support-page__videos">
          <YoutubeColumns videos={WALKTHROUGH_VIDEOS} />
        </div>
        <div className="support-page__contact">
          <p>Please contact an administrator with any other questions.</p>
        {/*
          <a href={`mailto:${SUPPORT_EMAIL}`} className="support-page__email">
            {SUPPORT_EMAIL}
          </a>
          */}
        </div>
      </section>
    </main>
  );
}
